export default "__VITE_ASSET__JjXJ2F2h__"